import React from "react";
import {Helmet} from "react-helmet";

export const ProductDetailPageMeta = () => (
    <Helmet>
        <title>Textura Digital Art Frame &amp; Canvas</title>
        <meta name="description" content="Textura Digital Canvas: A Digital Art Frame for Your Home"/>
            <meta name="keywords"
                  content="digital canvas, digital frame, digital art frame,  digital art canvas,picture frame,  frame, the frame, smart frame, smart digital art frame,  digital art, art, photography frame, artworks, gallery, photo frame, digital photo frame, textura, texturite technology, VT27WGV1, vieunite, digital photo to canvas, digital picture frame, best digital picture frame, electronic photo frame, wifi picture frame, video picture frame"/>

            <meta name="twitter:card" content="summary_large_image"/>
            <meta name="twitter:site" content="@VieuniteHQ"/>
            <meta name="twitter:title" content="Textura Digital Art Frame &amp; Canvas"/>
            <meta name="twitter:description" content="Textura Digital Canvas: A Digital Art Frame for Your Home"/>
            <meta name="twitter:image" content="https://vieunite.com/img/Social Card - Textura.jpg"/>
        <meta property="og:type" content="article"/>
        <meta property="og:title" content="Textura Digital Art Frame &amp; Canvas"/>
        <meta property="og:description" content="Textura Digital Canvas: A Digital Art Frame for Your Home"/>
        <meta property="og:image" content="https://vieunite.com/img/Social Card - Textura.jpg"/>
        <meta property="og:image:width" content="930"/>
        <meta property="og:image:height" content="620"/>
    </Helmet>);
